import React, { useEffect, useState, useRef } from 'react';
import {
  startLoadingSpinner,
  startLoadingSpinnerNoScroll,
  stopLoadingSpinner
} from '../../csf-ufc-pivotal/includes/utils';
import PivotalSearchApi from "../../../js/csf/pivotal/PivotalSearchApi";
import PropTypes from 'prop-types';
import moment from 'moment';
import JustValidate from 'just-validate';
import JustValidatePluginDate from 'just-validate-plugin-date';
import { resetErrMessages, handleClickLinks, updateHeadingBasedOnUrl } from '../includes/utils';
import PivotalFormApi from "../../../js/csf/pivotal/PivotalFormApi";
import {
  CsfFournisseurRecognitionBeforeBeginningModal
} from "../includes/csf-fournisseur-recognition-before-beginning-modal";
import CsfFournisseurRecognitionRenewalTitle
  from "../includes/csf-fournisseur-recognition-renewal-title";

export function FournisseurRecognitionRequestStepOneBlock({ hasPreviousRenewalEndDate, trainingId, currentStep, onStepChange, accessToken, apiUrl, apiEnv, user, form, updateForm, urlHome, urlRequestRecognition, originalEndDate, updateActivityId, firstTimeNewRecognition, setFirstTimeNewRecognition, setContact }) {

  const [selectedLanguage, setSelectedLanguage] = useState('0'); // Initial state
  const [resourcePersons, setResourcePersons] = useState([]);
  const [beginningDate, setBeginningDate] = useState('');
  const [cycleBeginningDate, setCycleBeginningDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [formattedEndDate, setFormattedEndDate] = useState('');
  const [validator, setValidator] = useState(null);
  const [selectedResourcePerson, setSelectedResourcePerson] = useState('');
  const [ipfMatricule, setIpfMatricule] = useState('');
  const [ipfCompanyName, setIpfCompanyName] = useState('');
  const [titleFR, setTitleFR] = useState('');
  const [titleEN, setTitleEN] = useState('');
  const [descriptionFR, setDescriptionFR] = useState('');
  const [descriptionEN, setDescriptionEN] = useState('');
  const [ipfErrorOrg, setIpfErrorOrg] = useState(false);
  const [ipfErrorMat, setIpfErrorMat] = useState(false);

  // isWebsiteChecked / setIsWebsiteChecked : Envoyé à l'IPF?
  const [isSentToIPF, setIsSentToIPF] = useState('');
  // isRegionChecked / setIsRegionChecked : affiché sur le site de l'IPF
  const [isDisplayedOnIPFSite, setIsDisplayedOnIPFSite] = useState('');

  const language = document.querySelector('html').getAttribute('lang');
  const endDatePickerRef = useRef(null);
  const [recognitionOfferedOnce, setRecognitionOfferedOnce] = useState(false);
  const formattedBeginningDate = beginningDate
    ? language === 'en'
      ? moment(beginningDate).locale('en-GB').format('MMMM Do, YYYY')
      : moment(beginningDate).locale(language === 'en' ? 'en-GB' : 'fr').format('Do MMMM YYYY')
    : '';

  const urlParams = new URLSearchParams(window.location.search);
  const isRenewal = (urlParams.get('renewal') === 'true' || hasPreviousRenewalEndDate);
  // keep as distinct property from isRenewal, used to influence how the request is saved

  const [recognitionType, setRecognitionType]  = useState((isRenewal ? 'renewal': 'new'));

  const [minimalStartDatePlusOneDay, setMinimalStartDatePlusOneDay] = useState(moment().add(-6,'months').format('YYYY-MM-DD'));

  /*
    * Method that handle the show up checkbox field of region to display or not the region fields.
    * */
  function handleRegionChange(event) {
    setIsDisplayedOnIPFSite(event.target.checked);
  }

  /*
  * On components mounts display the spinner.
  * */
  useEffect(() => {
    startLoadingSpinner();
  }, []);

  /*
  * When the accessToken is fetched and state is updates, get all the regions and the resource person.
  * */
  useEffect(() => {
    if (accessToken) {
      getRescourcePersons();
    }
  }, [accessToken]);

  /*
  * When the form is fetched, matched the existing date if any to the right fields and generate the regions.
  * */
  useEffect(() => {
    setSelectedLanguage(form?.Language_?.toString() ?? '0');
    hideShowElementsByLanguage((form?.Language_?.toString() ?? '0'));

    if (form && form.Cycle__Secondary !== undefined && form.Cycle__Secondary.length > 0) {
      setCycleBeginningDate(new moment(new Date(form?.Cycle__Secondary[form.Cycle__Secondary.length - 1]?.Start_Date)).utc().format('YYYY-MM-DD'));
      if (form.EP_MustBeRenew !== true) {
        setBeginningDate(new moment(new Date(form?.Cycle__Secondary[form.Cycle__Secondary.length - 1]?.Start_Date)).utc().format('YYYY-MM-DD'));
      }
    }

    setIsSentToIPF(form?.Submitted_To_Financial_Instit);
    setIsDisplayedOnIPFSite(form?.Showed_On_WebSite);
    setIpfCompanyName(form?.IPF_Company_Name);
    setSelectedResourcePerson(form?.Contact_Id);
    // to prevent conflicting data, set the matricule from the resourcePerson, not the form
    getTrainerInfoAndSetMatriculeField(form?.Contact_Id);
    setRecognitionOfferedOnce(form?.Recognition_Offered_Once);
    setTitleFR(form?.Name_French);
    setTitleEN(form?.Name_English);
    setDescriptionFR(form?.Desc_French);
    setDescriptionEN(form?.Desc_English);


    // wait for form to be initialized from api response in parent component
    if (form.hasOwnProperty('Cycle__Secondary')) {
      setRecognitionType(isRenewal || hasPreviousRenewalEndDate ? 'renewal': 'new');
    }

  }, [form]);


  /*
  * When the beginning date is selected, make the calculation for the end_date.
  * */
  useEffect(() => {
    setEndDate(calculateEndDate(beginningDate));
    setFormattedEndDate(calculateEndDate(beginningDate, "formatted"));
  }, [beginningDate, recognitionOfferedOnce]);

  /*
  * Effect fired for the form validation of the step 1.
  * */
  useEffect(() => {

    // method in utils.js to 'cleanup' residuals from previous validating
    resetErrMessages();

    const validator = new JustValidate('#form-step01');
    validator
      .addField('#resource-persons', [
        {
          rule: 'required',
          errorMessage: window.Drupal.t('fournisseur.creation_form.validation.required')
        },
      ]);

    validator
      .addField('#title-fr', [
        {
          rule: 'required',
          errorMessage: window.Drupal.t('fournisseur.creation_form.validation.required'),
        },
      ])
      .addField('#description-fr', [
        {
          rule: 'required',
          errorMessage: window.Drupal.t('fournisseur.creation_form.validation.required'),
        },
      ])
      .addField('#title-en', [
        {
          rule: 'required',
          errorMessage: window.Drupal.t('fournisseur.creation_form.validation.required'),
        },
      ])
      .addField('#description-en', [
        {
          rule: 'required',
          errorMessage: window.Drupal.t('fournisseur.creation_form.validation.required'),
        },
      ]);


      if (isRenewal) {
        validator.removeField('#title-fr');
        validator.removeField('#description-fr');
        validator.removeField('#title-en');
        validator.removeField('#description-en');
      }
      else if (document.querySelector('input[name="language"]:checked')?.value === '0') {
        validator.removeField('#title-en');
        validator.removeField('#description-en');
      }
      else if (document.querySelector('input[name="language"]:checked')?.value === '1') {
        validator.removeField('#title-fr');
        validator.removeField('#description-fr');
      }
      else if (document.querySelector('input[name="language"]:checked')?.value === '2') {
        validator.removeField('#description-en');
      }

    // Renouvellement :
    // le renouvellement ne peut commencer qu'une journée après la fin de la formation initiale
    //   (ex : si fin 1re juillet 2028, début ne peut pas être avant le 2 juillet - 2028).
    let mustBeAfterDate = originalEndDate;
    let plusOneDayMoment = null;
    if (form?.Renew_Cycle_End_Date !== null && form?.Renew_Cycle_End_Date !== '') {
      // Les renouvellements doivent debuter le lendemain de Renew_Cycle_End_Date
      let momentCycleEnd = new moment(new Date(form?.Renew_Cycle_End_Date));
      mustBeAfterDate = momentCycleEnd.utc().format('YYYY-MM-DD');
      plusOneDayMoment = momentCycleEnd.add(1, 'days');
    }

    if (mustBeAfterDate !== null && (isRenewal || hasPreviousRenewalEndDate)) {
      // for minimal date in start date picker widget, allow only starting the following date
      let minimalStartDateCalendar;
      let sixMonthAgo = moment().add(-6, 'months').format('YYYY-MM-DD');

      if (plusOneDayMoment !== null) {
        minimalStartDateCalendar = plusOneDayMoment?.format('YYYY-MM-DD');
      } else {
        minimalStartDateCalendar = mustBeAfterDate;
      }
      //Donne la possibilité de Start 6 mois avant la date de création sans dépassé la fin du dernier cycle
      setMinimalStartDatePlusOneDay(sixMonthAgo < minimalStartDateCalendar ? minimalStartDateCalendar : sixMonthAgo);

      validator.addField('#beginning-date', [
        {
          rule: 'required',
          errorMessage: window.Drupal.t('fournisseur.creation_form.validation.required')
        },
        {
          plugin: JustValidatePluginDate(() => ({
            isAfter: mustBeAfterDate,
          })),
          errorMessage: window.Drupal.t('fournisseur.form.date.isAfter.validate.msg'),
        }
      ]);
    } else {
      validator.addField('#beginning-date', [
        {
          rule: 'required',
          errorMessage: window.Drupal.t('fournisseur.creation_form.validation.required')
        },
      ]);
    }

    if (isSentToIPF) {
      validator.addField('#resource-person-matricule-ipf', [
        {
          rule: 'required',
          errorMessage: window.Drupal.t('fournisseur.creation_form.validation.required')
        }
      ]);
    }

    setValidator(validator);

  }, [selectedLanguage, originalEndDate, beginningDate, isRenewal, isSentToIPF]);

  /*
  * Effect that update the end_date value of the field.
  * */
  useEffect(() => {
    if (endDatePickerRef.current && endDate) {
      endDatePickerRef.current = endDate;
    }
  }, [endDate]);

  /*
  * Method that handle the change of the form title to display something different if it's a renewal or not.
  * */
  useEffect(() => {
    updateHeadingBasedOnUrl("step1", "renewal", window.Drupal.t('fournisseur.creation_form.page.title'), window.Drupal.t('fournisseur.creation_form.page.renew.title'), hasPreviousRenewalEndDate);
  }, [hasPreviousRenewalEndDate]);

  /*
  * Focus on IPF error if there is any
  * */
  useEffect(() => {
    document.querySelector('.custom-error-field')?.focus();
  }, [ipfErrorOrg,ipfErrorMat]);

  /*
  * Method that fetch the resource person for the training.
  * */
  function getRescourcePersons() {
    const requestData = {
      search: 'CSF_EP_RessourcePerson_REST',
      searchResultsList: 'CSF_EP_RessourcePerson_SRL'
    };

    const pivotalSearchApi = new PivotalSearchApi(apiUrl, apiEnv, accessToken);

    pivotalSearchApi.callSearchEndpoint(requestData, '_Espace_Partenaire')
      .then(response => {
        if (response?.success && response?.payload?.data?.rows?.length >= 0) {
          setResourcePersons(response.payload.data.rows);
          stopLoadingSpinner();
        }
      })
      .catch(error => {
        stopLoadingSpinner();
        console.error(error);
      });
  }

  /*
  * Method that handle the next button to go to step 2.
  * */
  function handleNextStepClick() {
    setFirstTimeNewRecognition(false);
    onStepChange(currentStep + 1); // Call the callback function with new count
  }

  /*
  * handle the form submission to pivotal
  * */
  function saveFormStep1ToApi(formStep1data) {
    let requestData = {
      form: 'CSF_EP_UXRecognition_1_REST',
      deltaData: { ...formStep1data }
    };

    if (trainingId !== '' && trainingId !== null) {
      requestData.recordId = trainingId;
    }

    startLoadingSpinner();

    const pivotalFormApi = new PivotalFormApi(apiUrl, apiEnv, accessToken);
    pivotalFormApi.callFormPutEndpoint(requestData, '_Espace_Partenaire')
      .then(response => {
        if (response?.success && response?.payload != null && response?.payload?.recordId != null) {
          addRecordIdToUrl(response.payload.recordId);
          updateActivityId(response.payload.recordId);
          stopLoadingSpinner();
          console.log("%c Save step 1 successful", 'background: #5E5E5E; color: #0f0');
          handleNextStepClick();
        }
        if (!response.success) {
          stopLoadingSpinner();
          setIpfErrorOrg(response.errorText?.includes("ERR_EP_IPF_ORG_01") ?? false);
          setIpfErrorMat(response.errorText?.includes("ERR_EP_IPF_MAT_01") ?? false);
          console.error(response.errorText);
        }
      })
      .catch(error => {
        stopLoadingSpinner();
        console.error(error);
      });
  }

  /*
  * Method to submit step 1 to local storage instead of pivotal api because we need to submit step 1 and 2 together.
  * */
  function saveStep1ToLocalStorage(event) {
    event.preventDefault(); // Prevent page refresh.

    const formData = {
      Contact_Id: selectedResourcePerson,
      Recognition_Offered_Once: recognitionOfferedOnce,
      Contact_Open_By_Id: user.Contact_Id,
      Submitted_To_Financial_Instit: isSentToIPF,
      Showed_On_WebSite: isDisplayedOnIPFSite,
      Redu_Activity_Type_Id: 'Type',
      Cycle__Secondary: [{
        REDU_Activity__Cycle_Id: form?.Last_REDU_Cycle_Id ? form.Last_REDU_Cycle_Id : "",
        Start_Date: beginningDate,
        End_Date: endDate,
      }],
      Language_: selectedLanguage,
      Name_French: titleFR,
      Name_English: titleEN,
      Desc_French: descriptionFR,
      Desc_English: descriptionEN,
    };
    if (formData.Submitted_To_Financial_Instit) {
      formData.Contact_Id_IPF_Matricule = ipfMatricule;
      formData.IPF_Company_Name = ipfCompanyName;
    }

    // Lors de la sauvegarde Cycle__Secondary.REDU_Activity__Cycle_Id doit toujours etre vide(Sauf en brouillon).
    // Les nouvelles dates sauvegardées, par exemple, le seront retournées par l'API sur le cycle qu'une fois la demande complétée/payée.
    if (isRenewal && form?.Renew_Cycle_End_Date == form?.Cycle__Secondary[0].End_Date) {
      formData.Cycle__Secondary[0].REDU_Activity__Cycle_Id = '';
    }

    if (validator) {
      resetErrMessages();
      validator.validate();
      setTimeout(() => {
        if (validator?.isValid) {
          localStorage.setItem('form', JSON.stringify(formData));
          updateForm(formData);

          // step1 save to api handles moving to next step
          saveFormStep1ToApi(formData);
        } else {
          console.error('Form validation failed!');
        }
      });
    }
  }


  /*
  * Method to calculate the end date of the training (same date 2 years from now -1 day EX: 15 juin 2024 - 14 juin 2026).
  * */
  function calculateEndDate(beginningDate, format = '') {
    if (!beginningDate) {
      return ''; // Handle empty or null beginningDate
    }
    let date = moment(beginningDate, 'YYYY-MM-DD');

    if (recognitionOfferedOnce !== true) {
      // Add 2 years
      date.add(2, 'years');
      // Subtract 1 day
      date.subtract(1, 'day');
    } else {
      // add 1 day
      date.add(1, 'day');
    }

    // Format the date based on the desired format
    if (format === 'formatted') {
      return language === 'en'
        ? date.locale('en-GB').format('MMMM Do, YYYY')
        : date.locale(language === 'en' ? 'en-GB' : 'fr').format('Do MMMM YYYY')
    } else {
      return date.format('YYYY-MM-DD');
    }
  }

  /*
  * Method to handle the resource person change in the dropdown field.
  * */
  function handleResourcePersonChange(event) {
    setSelectedResourcePerson(event.target.value);
    // set selected Resource Person IPF Matricule in corresponding field when selecting
    getTrainerInfoAndSetMatriculeField(event.target.value);
  }

  /*
  * Method to fetch the trainer info and set the matricule field accordingly in the form.
  * */
  function getTrainerInfoAndSetMatriculeField(trainerContactId) {
    startLoadingSpinnerNoScroll();

    if (!trainerContactId) {
      setIpfMatricule('');
      stopLoadingSpinner();
      return;
    }

    const requestData = {
      form: 'CSF_EP_UXContact_Info',
      recordId: trainerContactId,
    };
    const pivotalFormApi = new PivotalFormApi(apiUrl, apiEnv, accessToken);
    pivotalFormApi.callFormRecuperationEndpoint(requestData, '_Espace_Partenaire')
      .then(response => {
        if (response?.success && response?.payload?.data?.primary?.Contact_Id) {
          const matriculeValue = response.payload.data.primary.IPF_Matricule_Bridge !== null ? response.payload.data.primary.IPF_Matricule_Bridge : ""
          setContact(response.payload.data.primary);
          setIpfMatricule(matriculeValue);
          stopLoadingSpinner();
        } else {
          setIpfMatricule('');
        }
      })
      .catch(error => {
        setIpfMatricule('');
        stopLoadingSpinner();
        console.error(error);
      });
  }

  /*
  * Method to handle change of the beggining date field.
  * */
  function handleBeginningDateChange(event) {
    setBeginningDate(event.target.value);
    setEndDate(calculateEndDate(event.target.value));
  }

  /*
   * Add the activity id to the url to allow proper save of same request in next steps.
   */
  function addRecordIdToUrl(recordId) {
    const url = window.location.href
    const urlParams = new URLSearchParams(window.location.search);
    if (!urlParams.has('activity')) {
      const newUrl = url + '?activity=' + recordId;
      window.history.pushState({ path: newUrl }, '', newUrl);
    }
  }

  /*
  * Method that handle the show up on website field checked/unchecked.
  * */
  function handleWebsiteChange(event) {
    setIsSentToIPF(event.target.checked);
  }

  function handleIpfCompanyChange(event) {
    setIpfCompanyName(event.target.value);
  }


  // Languages radio buttons
  const handleRadioChange = (event) => {
    setSelectedLanguage(event.target.value.toString());

    // change visibility of title and description inputs
    hideShowElementsByLanguage(event.target.value.toString());
  }

  function hideShowElementsByLanguage(langRadioValue) {
    // show the mandatory indicator by default
    document.getElementById('description-en-mandatory-indicator').classList.remove('hidden');

    if (langRadioValue === '0') {
      // french
      document.querySelectorAll('.english-content').forEach(function (element) {
        element.classList.add('hidden');
        element.classList.remove('row');
      });
      document.querySelectorAll('.french-content').forEach(function (element) {
        element.classList.remove('hidden');
        element.classList.add('row');
      });
    } else if (langRadioValue === '1') {
      // english
      document.querySelectorAll('.english-content').forEach(function (element) {
        element.classList.remove('hidden');
        element.classList.add('row');
      });
      document.querySelectorAll('.french-content').forEach(function (element) {
        element.classList.add('hidden');
        element.classList.remove('row');
      });

    } else {
      // bilingue
      document.querySelectorAll('.english-content, .french-content').forEach(function (element) {
        element.classList.remove('hidden');
        element.classList.add('row');
        // mandatory indicator for description is hidden in english when bilingual
        document.getElementById('description-en-mandatory-indicator').classList.add('hidden');
      });
    }
  }

  /*
  * Method that determines if the language name given is the same as the training language
  * Parameters:
  * - languageToTest: language name to test against, usually the display language (string)
  * - selectedLanguage: the training language (int)
  *   0 = french, 1 = english, 2 = both
  * Return: bool
  * */
  function isSelectedLanguage(languageToTest, selectedLanguage) {
    if (selectedLanguage === '2') return true;

    if (languageToTest === "french") {
      return selectedLanguage === '0';
    }

    if (languageToTest === "english") {
      return selectedLanguage === '1';
    }
  }

  return (
    <main className="fournisseur recognition">

      <h1 id="step1">{window.Drupal.t('fournisseur.creation_form.page.title')}</h1>

      <CsfFournisseurRecognitionRenewalTitle
        isRenewal={isRenewal || hasPreviousRenewalEndDate}
        formData={form} />

      <div className="content">

        <aside className="form-steps-legend">
          <ol>
            <li className="active"><span>{window.Drupal.t('fournisseur.creation_form.steps.step1')}</span></li>
            <li><span>{window.Drupal.t('fournisseur.creation_form.steps.step2')}</span></li>
            <li><span>{window.Drupal.t('fournisseur.creation_form.steps.step3')}</span></li>
            <li><span>{window.Drupal.t('fournisseur.creation_form.steps.step4')}</span></li>
            <li><span>{window.Drupal.t('fournisseur.creation_form.steps.step5')}</span></li>
            <li><span>{window.Drupal.t('fournisseur.creation_form.steps.step6')}</span></li>
          </ol>
        </aside>

        <div className="form-steps-content">
          <form onSubmit={saveStep1ToLocalStorage} id="form-step01" autoComplete="off" noValidate="novalidate">
            <fieldset>
              <legend
                className="visually-hidden">{window.Drupal.t('fournisseur.creation_form.page.title')}</legend>
              <input type="hidden" name="contactId"
                     value={user.Contact_Id || ''}/>

              <div
                className="form-group special-padding d-flex align-items-center">
                <input
                  type="checkbox"
                  id="iqpf-submit"
                  name="iqpf-submit"
                  checked={isSentToIPF}
                  onChange={isRenewal ? undefined : handleWebsiteChange}
                  disabled={isRenewal}
                />
                <label
                  htmlFor="iqpf-submit">{window.Drupal.t('fournisseur.creation_form.form.fields.chk_also_iqpf')}</label>
              </div>

              {/* isWebsiteChecked refers to this being an IPF request */}
              {isSentToIPF && (
                <div className="form-container no-border">
                  <div className="form-group">
                    <label
                      htmlFor="ipf-entreprise-name">
                      {window.Drupal.t('fournisseur.creation_form.form.fields.ipf_entreprise_name_label')}
                    </label>
                    <input type="text"
                           id="ipf-entreprise-name"
                           name="ipf-entreprise-name"
                           onChange={handleIpfCompanyChange}
                           defaultValue={form?.Company_IPF_Nom}
                           className={ipfErrorOrg ? 'custom-error-field' : ''}/>
                    { ipfErrorOrg && (
                      <div className="custom-error-label" style={{color: "rgb(184, 17, 17)"}}>
                        {window.Drupal.t('fournisseur.creation_form.form.ipf.error_org')}
                      </div>
                    )}

                    <div className="prereq-content-notice">
                      <h3>{window.Drupal.t('fournisseur.creation_form.form.note_ipf_entreprise_name.title')}</h3>
                      <div>{window.Drupal.t('fournisseur.creation_form.form.note_ipf_entreprise_name.description')}</div>
                    </div>

                  </div>
                </div>
              )}

              <div className="form-group">
                <label
                  htmlFor="name">{window.Drupal.t('fournisseur.creation_form.form.fields.opened_by')}</label>
                <input id="name" type="text" name="name" value={
                  form?.Contact_Open_By_Id__Rn_Descriptor
                    ? form.Contact_Open_By_Id__Rn_Descriptor
                    : user.Contact_Id__Rn_Descriptor || ''
                } disabled/>
              </div>

              <div className={'row'}>
              <div className={'col-12 ' + (isSentToIPF ? 'col-xl-9' : 'col-xl-12')}>
                <div className="form-group">
                <label
                  htmlFor="resource-persons">{window.Drupal.t('fournisseur.creation_form.form.fields.res_person')}*</label>
                <select id="resource-persons" name="resource-persons"
                        value={selectedResourcePerson || ''}
                        onChange={handleResourcePersonChange}>
                  <option></option>
                  {resourcePersons.map((resourcePerson) => (
                    <option key={resourcePerson.Contact_Id}
                            value={resourcePerson.Contact_Id}>
                      {resourcePerson.Contact_Id__Rn_Descriptor}
                    </option>
                  ))}
                </select>
                </div>
              </div>

              {/* isWebsiteChecked refers to this being an IPF request */}
              {isSentToIPF && (
                <div className={'col-12 col-xl-3'}>
                  <div className="form-group">
                  <label
                    htmlFor="resource-person-matricule-ipf">
                    {window.Drupal.t('fournisseur.creation_form.form.fields.res_person_matricule_label')}
                  </label>
                  <input type="text"
                         id="resource-person-matricule-ipf"
                         name="resource-person-matricule-ipf"
                         value={ipfMatricule}
                         onChange={e => setIpfMatricule(e.target.value)}
                         className={ipfErrorMat ? 'custom-error-field' : ''}/>
                    { ipfErrorMat && (
                      <div className="custom-error-label" style={{color: "rgb(184, 17, 17)"}}>
                        {window.Drupal.t('fournisseur.creation_form.form.ipf.error_mat')}
                      </div>
                    )}
                  </div>
                </div>
              )}
              </div>


              <fieldset>
                <legend
                  className="visually-hidden">{window.Drupal.t('fournisseur.creation_form.page.title')}</legend>
                <div className="form-group form-group-inline">
                  <span>{window.Drupal.t('fournisseur.creation_form.form.fields.training.chk_lang_title')}</span>
                  <div style={{verticalAlign: "middle"}}>
                    <input type="radio" value="0" name="language" id="language1"
                           onChange={handleRadioChange}
                           checked={selectedLanguage === '0'}
                           disabled={isRenewal}/>
                    <label
                      htmlFor="language1">{window.Drupal.t('fournisseur.creation_form.form.fields.training.chk_lang_fr')}</label>
                  </div>
                  <div style={{verticalAlign: "middle"}}>
                    <input type="radio" value="1" name="language" id="language2"
                           onChange={handleRadioChange}
                           checked={selectedLanguage === '1'}
                           disabled={isRenewal}/>
                    <label
                      htmlFor="language2">{window.Drupal.t('fournisseur.creation_form.form.fields.training.chk_lang_en')}</label>
                  </div>
                  <div style={{verticalAlign: "middle"}}>
                    <input type="radio" value="2" name="language" id="language3"
                           onChange={handleRadioChange}
                           checked={selectedLanguage === '2'}
                           disabled={isRenewal}/>
                    <label
                      htmlFor="language3">{window.Drupal.t('fournisseur.creation_form.form.fields.training.chk_lang_biligual')}</label>
                  </div>
                </div>

                <div className="row french-content">
                  <div className="col-12">
                    <div className="form-group">
                      <label
                        htmlFor="title-fr">{window.Drupal.t('fournisseur.creation_form.form.fields.training.title_fr')}*</label>
                      <input type="text" name="title-fr" id="title-fr"
                             defaultValue={titleFR || ''}
                             disabled={ !isSelectedLanguage('french', selectedLanguage) || isRenewal}
                             onChange={(e)=>{setTitleFR(e.target.value)}}/>
                    </div>
                  </div>
                </div>

                <div className="row french-content">
                  <div className="col-12">
                    <div className="form-group">
                      <label htmlFor="description-fr"
                             className="label-with-bg"
                             style={{
                               backgroundColor: !isSelectedLanguage('french', selectedLanguage) || isRenewal ? '#bac9d1' : '#e9eef0',
                               marginLeft: "1px",
                               width: "calc(100% - 1px)"
                             }}>{window.Drupal.t('fournisseur.creation_form.form.fields.training.desc_fr')}*</label>
                      <textarea name="description-fr" id="description-fr"
                                className="form-textarea form-textarea-padding"
                                defaultValue={descriptionFR || ''}
                                disabled={!isSelectedLanguage('french', selectedLanguage) || isRenewal}
                                onChange={(e)=>{setDescriptionFR(e.target.value)}}></textarea>
                    </div>
                  </div>
                </div>

                <div className="row english-content">
                  <div className="col-12">
                    <div className="form-group">
                      <label
                        htmlFor="title-en">{window.Drupal.t('fournisseur.creation_form.form.fields.training.title_en')}*</label>
                      <input type="text" name="title-en" id="title-en"
                             defaultValue={titleEN || ''}
                             disabled={!isSelectedLanguage('english', selectedLanguage) || isRenewal}
                             onChange={(e)=>{setTitleEN(e.target.value)}}/>
                    </div>
                  </div>

                </div>

                <div className="row english-content">

                  <div className="col-12">
                    <div className="form-group">
                      <label htmlFor="description-en"
                             className="label-with-bg"
                             style={{
                               backgroundColor: !isSelectedLanguage('english', selectedLanguage) || isRenewal ? '#bac9d1' : '#e9eef0',
                               marginLeft: "1px",
                               width: "calc(100% - 1px)"
                             }}>{window.Drupal.t('fournisseur.creation_form.form.fields.training.desc_en')}
                        <span id="description-en-mandatory-indicator">*</span>
                      </label>
                      <textarea name="description-en" id="description-en"
                                className="form-textarea form-textarea-padding"
                                defaultValue={descriptionEN || ''}
                                disabled={!isSelectedLanguage('english', selectedLanguage) || isRenewal}
                                onChange={(e)=>{setDescriptionEN(e.target.value)}}></textarea>
                    </div>
                  </div>
                </div>

              </fieldset>

              {/* isWebsiteChecked refers to this being an IPF request */}
              {isSentToIPF && (
              <div
                className="form-group special-padding d-flex align-items-center">
                <input type="checkbox" id="displayed-on-iqpf"
                       name="displayed-on-iqpf" checked={isDisplayedOnIPFSite}
                       onChange={handleRegionChange}/>
                <label
                  htmlFor="displayed-on-iqpf">{window.Drupal.t('fournisseur.creation_form.form.fields.chk_shown_website')}</label>
              </div>
              )}

              <div
                className="form-group special-padding d-flex align-items-center">
                <input type="checkbox" id="offered-once" name="offered-once"
                       checked={recognitionOfferedOnce}
                       onChange={(event) => setRecognitionOfferedOnce(event.target.checked)}
                />
                <label
                  htmlFor="offered-once">{window.Drupal.t('fournisseur.creation_form.form.fields.chk_one_time')}</label>
              </div>

              <div className="row">
                <div className="col-12 col-xl-6">
                  <div className="form-group">
                    <label
                      htmlFor="beginning-date">{window.Drupal.t('fournisseur.creation_form.form.fields.date_start_recog')}*</label>
                    <input
                      type="date"
                      id="beginning-date"
                      name="beginning-date"
                      defaultValue={beginningDate}
                      min={minimalStartDatePlusOneDay}
                      onChange={handleBeginningDateChange}
                    />
                    {formattedBeginningDate && <div
                      className="formatted-dates light">{formattedBeginningDate}</div>}
                  </div>
                </div>
                <div className="col-12 col-xl-6">
                  <div className="form-group">
                    <label
                      htmlFor="end-date">{window.Drupal.t('fournisseur.creation_form.form.fields.date_end_recog')}</label>
                    <input
                      type="date"
                      id="end-date"
                      name="end-date"
                      defaultValue={endDate}
                      ref={endDatePickerRef}
                      disabled
                    />
                    {formattedEndDate && <div
                      className="formatted-dates dark">{formattedEndDate}</div>}
                  </div>
                </div>
              </div>

              <div className="row action-buttons">
                <div className="col text-center">
                  <button className="button btn-outlined btn-larger" type="button"
                          onClick={() => handleClickLinks(urlHome)}>
                    {window.Drupal.t('fournisseur.cancel.btn')}
                  </button>
                </div>
                <div className="col text-center">
                  <button className="button btn-larger" type="submit">
                    {window.Drupal.t('fournisseur.next.btn')}
                  </button>
                </div>
              </div>


            </fieldset>
          </form>
        </div>
      </div>

      {/* urlHome is the path to the Fournisseur section main page */}
      {(firstTimeNewRecognition === true) && (
        <>
        <CsfFournisseurRecognitionBeforeBeginningModal
          popupType={recognitionType}
          cancelRedirectUrl={urlHome}
          urlRequestRecognition={urlRequestRecognition}
        />
        </>
      )}


    </main>
  );
}

FournisseurRecognitionRequestStepOneBlock.propTypes = {
  hasPreviousRenewalEndDate: PropTypes.bool,
  trainingId: PropTypes.string,
  currentStep: PropTypes.number.isRequired,
  onStepChange: PropTypes.func,
  accessToken: PropTypes.string.isRequired,
  apiUrl: PropTypes.string.isRequired,
  apiEnv: PropTypes.string.isRequired,
  user: PropTypes.object.isRequired,
  form: PropTypes.object.isRequired,
  updateForm: PropTypes.func.isRequired,
  urlHome: PropTypes.string.isRequired,
  urlRequestRecognition: PropTypes.string,
  originalEndDate: PropTypes.string,
  updateActivityId: PropTypes.func.isRequired,
  firstTimeNewRecognition: PropTypes.bool.isRequired,
  setFirstTimeNewRecognition: PropTypes.func.isRequired,
  setContact: PropTypes.func.isRequired
}
